import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import ModalImage from "./ModalImage";

interface IProps {
    NoticeResult: INoticeDetails;
}

const Bloc2: React.FC<IProps> = ({
  NoticeResult
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalImage, setModalImage] = useState<any>();
  const [modalName, setModalName] = useState<string>();
  return (
    <>
     {NoticeResult?.ImageCouverture ? 
   <Card text='white' className="p-2">
      <Card.Img
    variant="top"
    src={
      NoticeResult?.ImageCouverture
        // ? NoticeResult?.ImageCouverture
        // : 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" style="background-color: %23dee2e6" width="240" height="240" viewBox="0 0 240 240"><path d="M20,170H220.78v20H20Zm200.78,60H30.43A10.42,10.42,0,0,1,20,219.53V210H220.78ZM20,149.81c0-13.06,3.74-29,29.91-33.64C80.58,110.69,214.25,69.48,220.78,2.26,223.58,76,105,143.28,20,149.81Z"/></svg>'
    }
    onClick={(e) => {
      e.preventDefault(); // Empêche le comportement par défaut du lien
      setModalImage(
        NoticeResult?.ImageCouverture
          // ? NoticeResult?.ImageCouverture
          // : 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" style="background-color: %23dee2e6" width="240" height="240" viewBox="0 0 240 240"><path d="M20,170H220.78v20H20Zm200.78,60H30.43A10.42,10.42,0,0,1,20,219.53V210H220.78ZM20,149.81c0-13.06,3.74-29,29.91-33.64C80.58,110.69,214.25,69.48,220.78,2.26,223.58,76,105,143.28,20,149.81Z"/></svg>'
      );
      setModalName("Couverture");
      setShowModal(true);
    }}
  />
</Card>
:<svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" className="electre_design-system_style_layout__dspl-block electre_design-system_style_layout__width vars-1057044457 electre_design-system_style_atom__icon-navy vars--795662912"><path d="M20,170H220.78v20H20Zm200.78,60H30.43A10.42,10.42,0,0,1,20,219.53V210H220.78ZM20,149.81c0-13.06,3.74-29,29.91-33.64C80.58,110.69,214.25,69.48,220.78,2.26,223.58,76,105,143.28,20,149.81Z"></path></svg>
  }
      
    <ModalImage
      show={showModal}
      image={modalImage}
      handleClose={() => setShowModal(false)}
      headerText={modalName}
    />
    </>
    
  );
};

export default Bloc2;
